export default __webpack_public_path__ + "static/media/profileImage9.3aeddfd0.png";